import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DailyDto, DailyRequestDto } from 'src/api/FiretrolApiClient';
import { formatDate } from 'src/utils';
import { dailyApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateDaily(jobId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: DailyRequestDto) => dailyApiClient.create(request),
    meta: {
      successMessageFn: (data) =>
        `Daily created for ${formatDate((data as DailyDto).date)}!`,
    },
    onSettled: () => invalidateFor('daily.write', qc, { jobId }),
  });
}

export function useUpdateDaily(jobId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, request }: { id: string; request: DailyRequestDto }) =>
      dailyApiClient.update(id, request),
    meta: {
      successMessageFn: (data) =>
        `Daily updated for ${formatDate((data as DailyDto).date)}!`,
    },
    onSettled: () => invalidateFor('daily.write', qc, { jobId }),
  });
}
